import createAction from '../services/create-action';

export const INSERT_TEXT_EDITOR_ENTITY = 'textEditor/INSERT_ENTITY';

export const insertTextEditorEntity = createAction(INSERT_TEXT_EDITOR_ENTITY);



// WEBPACK FOOTER //
// ./app/actions/insert-text-editor-entity.js